<template>
  <div class="mod-rm__coursetrainerrela course-trainer-contain-box">
    <div style="margin-top: 5px">
      <el-row :gutter="10">
        <el-col :span="18">
          <!--添加培训师-->
          <el-card class="box-card">
            <!--查询培训师-->
            <el-row>
              <el-col :span="24">
                <div ref="queryBox" class="queryBox">
                  <el-form
                    :label-position="labelPosition"
                    :label-width="queryLabelWidth"
                    class="traninerPool-search-condition"
                    :model="dataForm"
                  >
                    <el-row :gutter="0">
                      <!-- 培训师 -->
                      <el-col :span="7">
                        <el-form-item
                          class="oneBoxTrainer"
                          :label="$t('res.coursetrainerrela.trainer')"
                        >
                          <el-input
                            v-model="dataForm.trainer"
                            clearable
                            :placeholder="
                              $t('res.coursetrainerrela.trainerPlaceholder')
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <!-- 培训师标签 -->
                      <el-col :span="7">
                        <el-form-item
                          class="oneBoxTrainerLabel"
                          style="height: 34px"
                        >
                          <span slot="label">
                            <el-link
                              type="primary"
                              :underline="false"
                              slot="reference"
                              @click.native.prevent="showSuboLableDlg"
                              >{{
                                $t("res.coursetrainerrela.trainerLabel")
                              }}</el-link
                            >
                          </span>
                          <div
                            class="el-input el-input--default el-input__inner"
                            style="height: 30px"
                            @mouseenter="trainerLabelShow()"
                            @mouseleave="trainerLabelLeave()"
                          >
                            <div
                              style="float: left"
                              class="holder"
                              contenteditable="false"
                              :placeholder="$t('cert.selectTips')"
                            >
                              {{ this.dataForm.labelTypeIdName }}
                            </div>
                            <el-link
                              type="primary"
                              :underline="false"
                              class="el-icon-error link-delete-temp"
                              ref="trainerLabelLink"
                              v-show="
                                trainerLabelShowFlg &&
                                dataForm.labelTypeIdName != '' &&
                                dataForm.labelTypeIdName != null
                              "
                              style="
                                float: right;
                                margin-top: 9px;
                                color: rgba(0, 0, 0, 0.3);
                              "
                              @click="cleartrainerLabelName()"
                            ></el-link>
                          </div>
                        </el-form-item>
                      </el-col>
                      <!-- 培训师团队分类 -->
                      <el-col class="oneClassificationTrainersCol" :span="7" style="padding-left:10px">
                        <el-form-item
                          :label="$t('res.coursetrainerrela.trainerfication')"
                          prop="trainerficationArray"
                        >
                          <class-tree
                            ref="trainerficationRef"
                            v-on:getSelectList="getTrainerficationList"
                            v-bind:defaultProps="trainerficationProps"
                            v-bind:url="queryTrainerficationTreeUrl"
                            v-bind:isSelect="false"
                          ></class-tree>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3" class="query-button">
                        <!--查询按钮-->
                        <el-button
                          style="margin-bottom: 7px"
                          type="primary"
                          @click="queryTrainerInfo()"
                          >{{ $t("query") }}</el-button
                        >
                      </el-col>
                    </el-row>
                    <el-row :gutter="0">
                      <el-col :span="7">
                        <!--所在城市-->
                        <el-form-item
                          :label="$t('res.coursetrainerrela.city')"
                          class="twoPopupCity"
                          prop="cityList"
                        >
                          <class-tree
                            ref="cityclassRef"
                            v-on:getSelectList="getCitySelectList"
                            v-bind:defaultProps="citydefaultProps"
                            v-bind:isOpen="false"
                            v-bind:url="queryCityTreeUrl"
                            v-bind:isSelect="false"
                          ></class-tree>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item class="module-company-select" :label="$t('res.coursetrainerrela.companyNameCode')" prop="queryOrgId">
                          <el-select
                            v-model="dataForm.queryOrgId"
                            filterable
                            remote
                            reserve-keyword
                            clearable
                            :placeholder="$t('res.coursetrainerrela.companyNameCode')"
                            :remote-method="remoteCompanyMethod"
                            v-loading="companyLoading">
                            <el-option
                              v-for="(item,index) in companyOptions"
                              :key="'company'+index"
                              :label="item.abbreviationCn +'-'+item.orgCode"
                              :value="item.orgId">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">&nbsp;</el-col>
                      <!-- 重置按钮 -->
                      <el-col :span="3" class="query-button">
                        <el-col :span="24">
                          <el-button
                            class="el-back M-margin-l"
                            type="info"
                            @click="resetQuery()"
                            >{{ $t("reset") }}</el-button
                          >
                        </el-col>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-col>
            </el-row>
            <!-- 数据网格 -->
            <div class="dataBox">
              <el-table
                border
                ref="selectTrainerinfo"
                :data="dataList"
                v-loading="dataListLoading"
                size="mini"
                stripe
                @select="selectRedio"
                @select-all="selectAllRedio"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="50"
                  :selectable="checkboxT"
                >
                </el-table-column>
                <el-table-column
                  prop="xh"
                  fixed
                  :label="$t('res.courseclassroomrela.serialNo')"
                  type="index"
                  min-width="55"
                  header-align="center"
                  align="center"
                />
                <!-- 培训师id -->
                <el-table-column
                  prop="trainerId"
                  header-align="center"
                  v-if="false"
                  align="center"
                  :label="$t('res.courseclassroomrela.serialNo')"
                >
                </el-table-column>
                <!-- 培训师标签 -->
                <el-table-column
                  prop="trainerLabel"
                  header-align="center"
                  v-if="false"
                  align="center"
                  :label="$t('res.courseclassroomrela.serialNo')"
                >
                  <template slot-scope="scope">
                    <span
                      class="el-dropdown-link"
                      v-if="scope.row.numberLaber !== null"
                      @click="checkLable(scope.row)"
                      >{{ $t("view") }}</span
                    >
                  </template>
                </el-table-column>
                <!-- 培训师用户名 -->
                <el-table-column
                  prop="userName"
                  header-align="center"
                  align="center"
                  width="100"
                  show-overflow-tooltip
                  label="用户ID"
                >
                </el-table-column>
                <!-- 员工号 -->
                <el-table-column
                  prop="userCardNo"
                  header-align="center"
                  align="center"
                  :width="100"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.userCardNo')"
                >
                </el-table-column>
                <!-- 培训师名称 -->
                <el-table-column
                  prop="trainerName"
                  header-align="center"
                  align="center"
                  :width="100"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.trainerEnName')"
                >
                </el-table-column>
                <!-- 培训师编号 -->
                <el-table-column
                  prop="trainerNo"
                  header-align="center"
                  align="center"
                  :width="110"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.trainerNo')"
                >
                </el-table-column>
                <!-- 公司类型 -->
                <el-table-column
                  prop="orgType"
                  :formatter="orgFormatter"
                  header-align="center"
                  align="center"
                  :width="100"
                  show-overflow-tooltip
                  label="组织类型"
                >
                </el-table-column>
                <!-- 公司名称 -->
                <el-table-column
                  prop="companyDistributor"
                  header-align="center"
                  align="center"
                  :width="100"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.companyDistributor')"
                >
                </el-table-column>
                <!-- 培训师团队分类 -->
                <el-table-column
                  prop="trainerfication"
                  header-align="center"
                  align="center"
                  :width="160"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.trainerfication')"
                >
                </el-table-column>
                <!-- 所在城市 -->
                <el-table-column
                  prop="city"
                  header-align="center"
                  align="center"
                  :width="100"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.city')"
                >
                </el-table-column>
                <!-- 当前年度 -->
                <el-table-column
                  prop="annual"
                  header-align="center"
                  align="center"
                  :width="70"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.annual')"
                >
                </el-table-column>
                <!-- 年度目标 -->
                <el-table-column
                  prop="reportAnnualTarget"
                  header-align="center"
                  align="center"
                  :width="80"
                  show-overflow-tooltip
                  :label="$t('res.courseclassroomrela.reportAnnualTarget')"
                >
                </el-table-column>
                <!-- 培训师角色 -->
                <el-table-column
                  prop="trainerRole"
                  :formatter="trainerRoleFormatter"
                  header-align="center"
                  align="center"
                  :width="100"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.trainerrole')"
                >
                </el-table-column>
                <!-- 手机号码 -->
                <!-- 加入该部门日期 -->
                <el-table-column
                  prop="jobcodeJoinDate"
                  header-align="center"
                  align="center"
                  :width="140"
                  show-overflow-tooltip
                  :label="$t('res.coursetrainerrela.jobcodeJoinDate')"
                >
                </el-table-column>
                <!-- 培训师状态 -->
              </el-table>
              <el-pagination
                @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </el-card>
        </el-col>
        <!--已选培训师-->
        <el-col :span="6">
          <el-card class="box-card">
            <div>
              <span class="dataBox" style="display:block; margin-bottom: 10px">{{
                $t("res.courseclassroomrela.selected")
              }}</span>
              <div>
                <el-row :gutter="10">
                  <el-col v-for="tag in trainerData" :key="tag.trainerId" style="overflow: hidden">
                    <el-tag
                      style="margin-bottom: 10px; width: 100%"
                      :key="tag.trainerId"
                      @close="handleClose(tag)"
                      closable
                      >{{ tag.trainerName }}</el-tag
                    >
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
          <div style="text-align: right; margin-top: 12px">
            <el-button size="mini" type="primary" @click="closeSuboTrainerDlg"
              >取 消</el-button
            >
            <el-button size="mini" type="primary" @click="onOk"
              >确 定</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <!--标签查询条件-->
    <el-dialog
      title="选择标签"
      :visible="isQueryShowLable"
      width="70%"
      append-to-body
      :before-close="showQueryLableClose"
    >
      <el-form label-position="top" label-width="150px" :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName" style="width: 100% !important">
                <tag
                  :checkedList="checkList"
                  :moduleId="moduleId"
                  :overLabelShow="true"
                  :closeShow="true"
                  :bussinessTypeId="bussinessTypeId"
                  :brandCode="bussinessTypeChecked"
                  @getBussinessType="getBussinessType"
                  @changeCheckedList="changeCheckedList"
                  ref="tagTree"
                  @fatherMethod="fatherMethod"
                ></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div>
        <el-button type="primary" @click="onOkLable">{{
          $t("res.rela.determine")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import mixinViewModule from "@/mixins/view-module";
import ClassTree from "@/components/rm/class-tree/index";
import Tag from "@/components/rm/label-select/index";
import VueI18n from "@/i18n";
import Vue from "vue";
export default {
  props: {
    trainerInfoList: {
      type: Array,
      required: false,
    },
    trainerList: null,
  },
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/rm/coursetrainerrela/queryTrainerlist",
        getDataListIsPage: true,
        deleteURL: "/rm/coursetrainerrela/delete",
        deleteIsBatch: true,
        exportURL: "/rm/coursetrainerrela/export",
      },
      dataForm: {
        trainer: "",
        trainerLabel: "",
        trainerfication: "",
        trainerStatus: "10",
        cityList: [],
        queryOrgId: ''
      },
      dataForms: {
        priority: "",
        qualfication: "",
      },
      dataFormHold: {
        trainerficationArray: [],
        trainerStatusArr: [],
      },
      isQueryShowLable: false,
      isShowLable: false,
      trainerLabelShowFlg: false,
      companyLoading: false,
      companyOptions: [],
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: "20",
      bussinessTypeId: 7,
      bussinessTypeChecked: 7,
      // 已选培训师
      trainerData: [],
      trainerInfo: {},
      statusArr: this.enums["status"], // 状态下拉框
      priorityArr: this.enums["priority"], // 优先级
      trainerficationArr: this.enums["teaTeamClass"], // 培训师团队分类
      qualficationArr: this.enums["qualfication"], // 资格
      dataListLoading: false,
      // 城市分类
      citydefaultProps: {
        children: "childrenRegionList",
        label: "regionNameCn",
      },
      queryCityTreeUrl: "/rm/courseclassroomrela/queryregiontree",
      // 标签树
      commLabelProps: {
        children: "children",
        label: "labelNameCn",
      },
      querycommLabelUrl: "/rm/coursetrainerrela/queryCommLabelNodeByNameRela",
      // 培训师团队分类
      trainerficationProps: {
        children: "children",
        label: "treamCnName",
      },
      queryTrainerficationTreeUrl: "/rm/rpc/treamClassTree/list",
      // 编辑面板标签对齐方式
      labelPosition: "left",
      // 查询面板标签宽度
      queryLabelWidth: "auto",
      trainerLabelList: [], // 标签
      dataRule: {
        priority: [
          {
            required: true,
            message: this.$t("res.courseclassroomrela.priorityCheck"),
            trigger: "blur",
          },
        ],
        qualfication: [
          {
            required: true,
            message: this.$t("res.coursetrainerrela.qualficationCheck"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Tag,
    "class-tree": ClassTree,
  },
  mounted() {
    this.initMethods();
  },
  methods: {
    remoteCompanyMethod (query) {
      if (query !== '') {
        this.companyLoading = true;
        setTimeout(() => {
          this.companyLoading = false;
          this.$request.get(`/sys/org/queryByOrgCodeOrName?limit=100&page=1&queryParam=${query}`).then((res) => {
            if (res) {
              this.companyOptions = res.records || []
            }
          }).catch(() => {
            this.companyOptions = [];
          })
        }, 200);
      } else {
        this.companyOptions = [];
      }
    },
    // 点击选择标签打开弹窗
    showSuboLableDlg() {
      this.isQueryShowLable = true;
    },
    //关闭选择标签弹窗
    showQueryLableClose() {
      this.isQueryShowLable = false;
    },
    cleartrainerLabelName() {
      this.dataForm.trainerLabel = "";
      this.dataForm.labelTypeIdName = "";
      this.checkList = [];
      this.trainerLabelShowFlg = false;
    },
    trainerLabelShow() {
      this.trainerLabelShowFlg = true;
    },
    trainerLabelLeave() {
      this.trainerLabelShowFlg = false;
    },
    changeCheckedList(array) {
      this.checkList = array;
    },
    onOkLable() {
      let args = this.checkList;
      if (args && args !== "" && args.length > 0) {
        let classLabelinfo = [];
        let classLabelinfoName = [];
        args.forEach(function (item) {
          classLabelinfo.push(item.labelId);
          classLabelinfoName.push(item.labelName);
        });
        this.dataForm.trainerLabel = classLabelinfo.join(",");
        this.dataForm.labelTypeIdName = classLabelinfoName.join(",");
      } else {
        this.dataForm.trainerLabel = "";
        this.dataForm.labelTypeIdName = "";
      }
      this.isQueryShowLable = false;
    },
    getBussinessType(val) {
      this.bussinessTypeId = val;
    },
    // 重新勾选业务标签
    fatherMethod() {
      // this.checkList = []
      // 已选择的标签
      // this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale;
      if (language === "zh-CN") {
        this.checkList.forEach((o) => {
          o.labelName = o.labelNameCn;
        });
      } else {
        this.checkList.forEach((o) => {
          o.labelName = o.labelNameEn;
        });
      }
    },
    // 获取数据列表
    getDataList() {
      debugger;
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm));
      if ("regionIds" in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = "";
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(",");
        }
      }
      this.dataListLoading = true;
      this.$request
        .get(this.mixinViewModuleOptions.getDataListURL, {
          order: this.order,
          orgId: this.dataForm.queryOrgId,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage
            ? this.page
            : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage
            ? this.limit
            : null,
          ...newDataForm,
        })
        .then((res, total, code, data) => {
          console.log(res);
          this.dataListLoading = false;
          let resultList = data.data.records;
          this.dataList = resultList;
          this.total = this.mixinViewModuleOptions.getDataListIsPage
            ? parseInt(data.data.total, 10)
            : 0;
          // 延迟加载
          this.$nextTick(() => {
            this.querSelect();
          });
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    initMethods() {
      debugger;
      this.$refs.tagTree && this.$refs.tagTree.isReset();
      this.trainerData = [];
      if (this.trainerList && this.trainerList.length > 0) {
        //深拷贝
        this.trainerData = JSON.parse(JSON.stringify(this.trainerList));
      }
      this.dataForm = {
        trainer: "",
        trainerLabel: "",
        labelTypeIdName: "",
        trainerfication: "",
        trainerStatus: "10",
        cityList: [],
        queryOrgId: ''
      };
      this.dataForms = {
        priority: "",
        qualfication: "",
      };
      this.dataFormHold = {
        trainerficationArray: [],
        trainerStatusArr: [],
      };
      this.$refs.cityclassRef.resetChecked();
      this.$refs.trainerficationRef.resetChecked();
      this.page = 1;
      this.getDataList();
      this.checkList = [];
      this.trainerLabelShowFlg = false;
      this.$request
        .get(`/rm/coursetrainerrela/queryBussinessTypeIdRela`)
        .then((res, total, code, data) => {
          if (data.data != null && data.data != undefined) {
            this.bussinessTypeId = data.data;
            this.bussinessTypeChecked = data.data;
          }
        });
    },
    // 状态转换
    statusFormatter(row) {
      return Vue.filter("coverEnum")(row.status, "status");
    },
    // 公司类型转换
    orgFormatter(row) {
      return Vue.filter("coverEnum")(row.orgType, "orgType");
    },
    // 培训师团队分类转换
    teamClassFormatter(row) {
      return Vue.filter("coverEnum")(row.groupTypeId, "teaTeamClass");
    },
    // 培训师角色转换
    trainerRoleFormatter(row) {
      return Vue.filter("coverEnum")(row.trainerRoleCode, "trainerRole");
    },
    selectRedio: function selectRedio(selection, row) {
      debugger;
      let result = [];
      for (let a = 0; a < selection.length; a++) {
        if (row.trainerId === selection[a].trainerId) {
          result.push(row);
          break;
        }
      }
      if (result.length > 0) {
        if (
          this.isSelectElection &&
          this.$refs.selectTrainerinfo.selection.length > 1
        ) {
          this.$refs.selectTrainerinfo.clearSelection(); // 清空
          this.trainerData = [];
          this.trainerData.push(row);
          this.$refs.selectTrainerinfo.toggleRowSelection(row); // 选择当前行
        } else {
          if (row) {
            this.trainerData.push(row);
          }
        }
      } else {
        if (
          this.isSelectElection &&
          this.$refs.selectTrainerinfo.selection.length > 1
        ) {
          this.$refs.selectTrainerinfo.clearSelection(); // 清空
          this.trainerData = [];
        } else {
          for (let b = 0; b < this.trainerData.length; b++) {
            if (row.trainerId === this.trainerData[b].trainerId) {
              this.trainerData.splice(b, 1);
              break;
            }
          }
        }
      }
    },
    // 控制可选项
    checkboxT(row, index) {
      let _this = this;
      let checkFlg = 1;
      if (_this.trainerInfoList && _this.trainerInfoList.length > 0) {
        _this.trainerInfoList.forEach(function (item) {
          if (row.trainerId === item.trainerId) {
            checkFlg = 0;
          }
        });
      }
      return checkFlg;
    },
    // 全选
    selectAllRedio(selection) {
      let _this = this;
      if (selection) {
        let trainerDataB = [];
        if (_this.trainerData && _this.trainerData.length > 0) {
          _this.trainerData.forEach(function (item) {
            trainerDataB.push(item);
          });
        }
        if (selection.length > 0) {
          for (var i = 0; i < selection.length; i++) {
            let hasFlg = false;
            if (trainerDataB && trainerDataB.length > 0) {
              for (var l = 0; l < trainerDataB.length; l++) {
                if (trainerDataB[l].trainerId === selection[i].trainerId) {
                  hasFlg = true;
                }
              }
            }
            if (!hasFlg) {
              _this.trainerData.push(selection[i]);
            }
          }
        } else {
          _this.trainerData = [];
          if (trainerDataB && trainerDataB.length > 0) {
            for (var j = 0; j < trainerDataB.length; j++) {
              let hasFlg = false;
              for (var k = 0; k < _this.dataList.length; k++) {
                if (trainerDataB[j].trainerId === _this.dataList[k].trainerId) {
                  hasFlg = true;
                }
              }
              if (!hasFlg) {
                _this.trainerData.push(trainerDataB[j]);
              }
            }
          }
        }
      }
    },
    // 确认
    onOk: function () {
      let _this = this;
      _this.$emit("onOk", _this.trainerData);
      _this.$refs.selectTrainerinfo.clearSelection();
    },
    // 重置查询条件
    resetQuery() {
      this.dataForm = {
        trainer: "",
        trainerLabel: "",
        trainerfication: "",
        trainerStatus: "10",
        cityList: [],
        queryOrgId: ''
      };
      this.dataFormHold = {
        trainerficationArray: [],
        trainerStatusArr: [],
      };
      this.$refs.cityclassRef.resetChecked();
      this.$refs.trainerficationRef.resetChecked();
      this.checkList = [];
      this.trainerData = [];
      this.$refs.tagTree && this.$refs.tagTree.isReset();
      this.queryTrainerInfo();
    },
    // 获取培训师标签
    getTrainerLabelList(args) {
      if (args && args !== "" && args.length > 0) {
        let trainerLabelinfo = [];
        args.forEach(function (item) {
          trainerLabelinfo.push(item.id);
        });
        this.dataForm.trainerLabel = trainerLabelinfo.join(",");
        console.log(this.dataForm.trainerLabel);
      } else {
        this.dataForm.trainerLabel = "";
      }
    },
    // 培训师团队分类
    getTrainerficationList(args) {
      if (args && args !== "" && args.length > 0) {
        let trainerficationSelect = [];
        args.forEach(function (item) {
          trainerficationSelect.push(item.id);
        });
        this.dataForm.trainerfication = trainerficationSelect.join(",");
      } else {
        this.dataForm.trainerfication = "";
      }
    },
    getCitySelectList(args) {
      if (args && args !== "" && args.length > 0) {
        let citySelect = [];
        args.forEach(function (item) {
          citySelect.push(item.id);
        });
        this.dataForm.cityList = citySelect.join(",");
      } else {
        this.dataForm.cityList = "";
      }
    },
    // 双击选择培训师数据
    onDbTrainer(val) {
      if (val) {
        if (this.trainerData) {
          for (var i = 0; i < this.trainerData.length; i++) {
            if (
              String(this.trainerData[i].trainerId) === String(val.trainerId)
            ) {
              this.$message.warning(this.$t("res.courseclassroomrela.ondb"));
              return false;
            }
          }
        }
        this.trainerData.push(val);
      }
    },
    // 打开页面时，回填勾选
    querSelect() {
      debugger;
      this.$refs.selectTrainerinfo.clearSelection();
      if (this.trainerData && this.trainerData.length > 0) {
        var map = new Map();
        this.trainerData.forEach(function (item, index) {
          map.set(String(item.trainerId), item);
        });
        let _this = this;
        _this.dataList.forEach(function (dataitem, dataindex) {
          if (map.has(String(dataitem.trainerId))) {
            _this.$refs.selectTrainerinfo.toggleRowSelection(dataitem);
          }
        });
      }
    },
    // 删除已选备件
    handleClose(data) {
      for (let a = 0; a < this.dataList.length; a++) {
        if (data.trainerId === this.dataList[a].trainerId) {
          this.$refs.selectTrainerinfo.toggleRowSelection(
            this.dataList[a],
            false
          ); // 选择当前行
          break;
        }
      }
      this.trainerData.splice(this.trainerData.indexOf(data), 1);
    },
    queryTrainerInfo() {
      this.page = 1;
      this.getDataList();
    },
    // 关闭dialog
    closeSuboTrainerDlg() {
      this.trainerData = [];
      this.$emit("closeSuboTrainerDlg");
    },
  },
};
</script>
<style scoped lang="scss">
.mod-rm__coursetrainerrela {
  .query-button {
    text-align: right;
  }
  .el-form-item {
    width: 100% !important;
    max-width: 280px !important;
    line-height: 32px !important;
    .el-form-item__label {
      height: 32px !important;
    }
  }
}
.oneBoxTrainer .el-form-item__label-wrap {
  margin-left: 28px !important;
}
.oneBoxTrainerLabel .el-form-item__label-wrap {
  margin-left: 0px !important;
}
.oneClassificationTrainersCol .el-form-item {
  width: 95% !important;
}
.twoPopupCity .el-form-item__label-wrap {
  margin-left: 16px !important;
}
</style>
<style lang="scss">
.course-trainer-contain-box {
  .el-form-item {
    display: flex !important;
  }
  .el-form-item__label-wrap{
    width: 110px;
    text-align: right;
    margin: 0 !important;
  }
  .el-form-item__content {
    flex: 1 !important;
    margin-left: 0 !important;
  }
}
</style>
